/**
 * @generated SignedSource<<c85f90efedc4ff73b043e51e69e1c439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopupsList_cl",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountPaymentT",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transactionTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "receivedAmount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "psType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ccBrand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ccLast4",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "achAccountNum",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountPaymentTsConnection",
  "abstractKey": null
};

node.hash = "b7103231e3b868e5b35ecfd788c1d8e5";

module.exports = node;
